<script>
    import Button from "@smui/button";

    import Select, { Option } from "@smui/select";
    import Textfield from "@smui/textfield";
    import { createEventDispatcher, onMount } from "svelte";
    import { post } from "../http";
    import page from "../page";
    import loading from "./loading";

    export let mode = "origin"; //origin / destination

    export let disabled = false;

    export let province = "",
        city = "",
        district = "",
        address = "",
        code = "";
    export let noaddress = false;

    let provinces = [],
        cities = [],
        districts = [];

    $: selectProvince(province);
    $: selectCity(city);
    $: selectDistrict(district);

    function selectProvince() {
        cities = [];
        districts = [];
        city = "";
        district = "";
        if (province == "") return;
        loading.show();
        const url = mode == "origin" ? "/api/city" : "/api/destination_city";
        post(url, { province: province })
            .then((resp) => {
                if (resp.status == 0) cities = resp.data;
            })
            .finally(() => loading.hide());
    }

    function selectCity() {
        districts = [];
        district = "";
        if (city == "") return;
        loading.show();
        const url =
            mode == "origin" ? "/api/district" : "/api/destination_district";
        post(url, { province: province, city: city })
            .then((resp) => {
                if (resp.status == 0) districts = resp.data;
            })
            .finally(() => loading.hide());
    }

    function selectDistrict() {
        if (district == "") return;
        const selDistrict = districts.find((i) => i.name == district);
        code = selDistrict.code;
        page.scrollToBottom();
    }

    onMount(() => {
        loading.show();
        const url =
            mode == "origin" ? "/api/province" : "/api/destination_province";
        post(url)
            .then((resp) => {
                if (resp.status == 0) provinces = resp.data;
            })
            .finally(() => loading.hide());
    });
</script>

{#if provinces.length > 0}
    <Select
        bind:value={province}
        variant="outlined"
        label="Provinsi"
        enhanced
        {disabled}>
        {#each provinces as p}
            <Option value={p.name} selected={province === p.name}>
                {p.name}
            </Option>
        {/each}
    </Select>
{/if}
{#if cities.length > 0}
    <Select
        bind:value={city}
        variant="outlined"
        label="Kota/Kabupaten"
        enhanced
        {disabled}>
        {#each cities as c}
            <Option value={c.name} selected={city === c.name}>{c.name}</Option>
        {/each}
    </Select>
{/if}
{#if districts.length > 0}
    <Select
        bind:value={district}
        variant="outlined"
        label="Kecamatan/Kelurahan"
        enhanced
        {disabled}>
        {#each districts as s}
            <Option value={s.name} selected={district === s.name}>
                {s.name}
            </Option>
        {/each}
    </Select>
{/if}
{#if !noaddress && district != ''}
    {#if district.code != ''}
        <Textfield
            textarea
            bind:value={address}
            label="Alamat Lengkap"
            input$rows="4"
            input$placeholder="Masukkan nama jalan/gedung/apartemen, no rumah, RT/RW, dan alamat lainnya"
            {disabled} />
    {/if}
{/if}
